// 重写全局上传逻辑
import Engine, {
  EngineInterface,
  FileInfo,
  File,
  getExtensionName,
  UploaderOptions,
} from '@aomao/engine';
import { upload } from "@/api"

export default class Upload {
  /* 上传前处理图片，获取文件的Blob在上传等待中显示在编辑器中 */
  handleBefore (uid: string, file: File) {
    const { type, name, size } = file;
    // 获取文件后缀名
    const ext = getExtensionName(file);
    // 异步读取文件
    return new Promise<Boolean | { file: File; info: FileInfo }>(
      (resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.addEventListener(
          'load',
          () => {
            const values = {
              file,
              info: {
                // 唯一编号
                uid,
                // Blob格式
                src: fileReader.result,
                // 文件名称
                name,
                // 文件大小
                size,
                // 文件类型
                type,
                // 文件后缀名
                ext,
              },
            };
            resolve(values);
          },
          false,
        );
        fileReader.addEventListener('error', () => {
          reject(false);
        });
        fileReader.readAsDataURL(file);
      }
    )
  }
  /* 重写全局upload */
  setGlobalUpload (engine: EngineInterface = new Engine('.container')) {
    // 重写编辑器中 upload 方法
    engine.request.upload = async (options, files, name) => {
      const { onBefore, onReady } = options;
      // 如果没有任何文件就不处理
      if (files.length === 0) {
        return
      };
      const promiseList = [];
      for (let f = 0; f < files.length; f++) {
        const file = files[f];
        // 当前上传文件唯一标识
        const uid = Date.now() + '-' + f;
        file.uid = uid;
        if (onBefore && (await onBefore(file)) === false) {
          return
        };
        promiseList.push(this.handleBefore(uid, file));
      }
      // 全部文件读取完成后再插入编辑器
      Promise.all(promiseList).then(async (values) => {
        if (values.some((value) => value === false)) {
          engine.messageError("2", 'read image failed');
          return;
        }
        const files = values as { file: File; info: FileInfo }[];
        Promise.all([
          ...files.map(async (v) => {
            return new Promise(async (resolve) => {
              if (onReady) {
                await onReady(v.info, v.file);
              }
              resolve(true);
            });
          }),
        ]).then(() => {
          files.forEach(async (file) => {
            // 处理上传
            this.handleUpload(file.file, options, name);
          });
        });
      });
    };
  }
  /**
   * 处理上传
   * @param url 上传地址
   * @param name formData 参数名称
   * @param file 文件
   */
  handleUpload (file: File, options: UploaderOptions, name: string = 'file') {
    // 表单数据
    const formData = new FormData();
    formData.append('file', file)
    // formData.append(name, file, file.name);
    // if (file.data) {
    // 	Object.keys(file.data).forEach((key) => {
    // 		formData.append(key, file.data![key]);
    // 	});
    // }
    const {
      // 上传地址
      url,
      // 额外数据
      data,
      // 上传中的进度回调
      onUploading,
      // 上传成功回调
      onSuccess,
      // 上传错误回调
      onError,
    } = options;
    if (data) {
      Object.keys(data).forEach((key) => {
        formData.append(key, data![key]);
      });
    }

    // 自定义上传，并调用 onUploading onSuccess onError 回调方法
    upload(formData).then(
      (res: { data: any }) => {
        if (res.data.code === 200) {
          const urlData: any = res.data.data;
          onSuccess({ url: urlData[0] }, file);
        } else {
          onError(new Error("上传失败"), file)
        }

      }
    ).catch(
      (e: any) => {
        onError(e, file)
      }
    )
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/mk-editor/tools/upload.ts